export class Address {
  id: number;
  postalCode: string;
  city: string;
  street: string;
  houseNumber: string;
  country: string;
  latitude: string;
  longitude: string;

  constructor(formValue?: Partial<Address>) {
    Object.assign(this, formValue);
  }
}
